import script from "./framework.vue?vue&type=script&setup=true&lang=js"
export * from "./framework.vue?vue&type=script&setup=true&lang=js"

import "./framework.vue?vue&type=style&index=0&id=e25527ac&lang=less&scoped=true"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e25527ac"]])

export default __exports__